export default {
  selectedTab: '1',
  versionProps: {
    title: '单行标题',
    widgetNum: '1',// 每种组件的唯一编码
    version: '1',  // 每种组件的版本号
    upgrade: true,
    docUrl: '/datavisual/doc/widget'
  },
  viewProps: {
    width: '200',
    height: '60',
    top: 0,
    left: 0,

    color: '#A8E3FF',
    fontSize: '16',
    fontWeight: '600',
    textAlign: 'left',

    dataConfig: {
      data: null,
    },
  },
  datasourceProps: {
    datasourceType: 'STATIC', // STATIC/API
    dataMapping: [ // table的映射采用数组，其他组件采用json
      {id: 1, prop:'text', label: "内容", field: 'title'},
    ],
    dataType: 'object', // 数据类型（string/number, array, object)
    dataConfig: {
      'STATIC': {
        data: {
          title: "文本"
        }
      },
      'API': {// API时候的请求参数
        datasource: null,
        datasourceLabel: null,
        reqParams: null,
        data: '',
      },
    }
  }
}
